import { CloseOutlined } from '@ant-design/icons';
import { getTeachersGeofenceLocations, storeEditedGeoFenceData, postAllocateGeoLocation, postSaveEditedGeoFence } from 'actions/attendanceNew';
import { Drawer, Select } from 'antd';
import { Button } from 'components/Button';
import moment from 'moment';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import './tabsStyles.css';
const pLocation = require("../../../Assets/userManagementV3/permenant location.png").default;
const tLocation = require("../../../Assets/userManagementV3/temp location.png").default;
const chevron = require('../../../Assets/userManagementV3/chevron.png').default;
const chevronNav = require('../../userManagementV2/dashboardV3/ic-chevron-down12.svg').default;
const calendarIcon = require('../../userManagementV2/dashboardV3/calendar.svg').default;

// FloatingLabelSelect: Clicking the label, the whole select input area,
// or the chevron arrow opens/toggles the dropdown.
const FloatingLabelSelect = ({ label, value, options, onSelect, required = false }) => {
    const [open, setOpen] = useState(false);
    const hasValue = !!value;
    const labelContent = (
        <>{label}{required && <span style={{ color: 'red' }}> *</span>}</>
    );

    return (
        <div
            style={{ width: '100%', marginTop: 12, cursor: 'pointer' }}
            onClick={() => setOpen((prev) => !prev)}
        >
            {hasValue && (
                <label
                    onClick={(e) => {
                        e.stopPropagation();
                        setOpen((prev) => !prev);
                    }}
                    style={{
                        display: 'block',
                        color: '#636363',
                        fontSize: 12,
                        lineHeight: '16px',
                        fontWeight: 400,
                        cursor: 'pointer',
                        marginBottom: 4,
                    }}
                >
                    {labelContent}
                </label>
            )}
            <div onClick={(e) => e.stopPropagation()}>
                <Select
                    open={open}
                    onDropdownVisibleChange={setOpen}
                    className="no-border-select-v3"
                    dropdownClassName="geofence-select-dropdown"
                    virtual={false}
                    style={{ width: '100%', marginTop: 0, cursor: 'pointer' }}
                    value={value || undefined}
                    options={options}
                    placeholder={labelContent}
                    suffixIcon={
                        <img
                            src={chevron}
                            alt="icon"
                            style={{
                                width: 24,
                                height: 24,
                                transform: open ? 'rotate(180deg)' : 'rotate(0deg)',
                                transition: 'transform 0.2s ease',
                                cursor: 'pointer',
                            }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setOpen((prev) => !prev);
                            }}
                        />
                    }
                    onSelect={(val, obj) => {
                        onSelect(val, obj);
                        setOpen(false);
                    }}
                    dropdownStyle={{ zIndex: 1050 }}
                />
            </div>
        </div>
    );
};

// Mon-first calendar grid for a given month, as a flat array of
// { date, inMonth } cells padded with leading/trailing days so the total
// length is always a multiple of 7 (full weeks only, no partial rows).
function buildCalendarCells(viewDate) {
    const startOfMonth = viewDate.clone().startOf('month');
    const daysInMonth = viewDate.daysInMonth();
    // moment's .day() is 0=Sunday..6=Saturday; shift so 0=Monday..6=Sunday.
    const firstWeekday = (startOfMonth.day() + 6) % 7;

    const cells = [];
    for (let i = firstWeekday; i > 0; i--) {
        cells.push({ date: startOfMonth.clone().subtract(i, 'days'), inMonth: false });
    }
    for (let d = 1; d <= daysInMonth; d++) {
        cells.push({ date: startOfMonth.clone().date(d), inMonth: true });
    }
    while (cells.length % 7 !== 0) {
        cells.push({ date: cells[cells.length - 1].date.clone().add(1, 'days'), inMonth: false });
    }
    return cells;
}

const WEEKDAY_LABELS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

// Fully custom calendar panel — no antd/rc-picker involved. Two earlier
// attempts at reskinning antd's DatePicker popup via CSS both broke its
// internal layout math (forced widths threw off where it anchors itself;
// swapping its nav icons collided with buttons it renders internally that
// CSS can't cleanly target), so this builds the exact spec'd panel from
// scratch instead of fighting a library's internals: 416px white card,
// drop shadow, "Month, Year" header with icon-based prev/next, a light
// purple weekday pill (Mon-first), and a solid purple circle on the
// selected date.
const CustomCalendar = ({ viewDate, selectedDate, onSelectDate, onPrevMonth, onNextMonth, disabledDate }) => {
    const cells = buildCalendarCells(viewDate);
    const rows = [];
    for (let i = 0; i < cells.length; i += 7) {
        rows.push(cells.slice(i, i + 7));
    }

    return (
        <div style={{
            width: 300,
            boxSizing: 'border-box',
            background: '#FFFFFF',
            borderRadius: 8,
            boxShadow: '4px 4px 16px rgba(0, 0, 0, 0.16)',
            padding: '16px',
        }}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <div style={{ fontFamily: 'Roboto, sans-serif', fontSize: 14, color: '#191919' }}>
                    {viewDate.format('MMMM')}, {viewDate.format('YYYY')}
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    {/* ic-chevron-down12's baked shape points up by default
                        (apex at the top) — used as-is for "previous month",
                        rotated 180° for "next month". */}
                    <img
                        src={chevronNav}
                        alt="previous month"
                        style={{ width: 11, height: 10, cursor: 'pointer' }}
                        onClick={onPrevMonth}
                    />
                    <img
                        src={chevronNav}
                        alt="next month"
                        style={{ width: 11, height: 10, cursor: 'pointer', transform: 'rotate(180deg)' }}
                        onClick={onNextMonth}
                    />
                </div>
            </div>
            <div style={{ display: 'flex', background: '#F4F0FF', borderRadius: 10, padding: '5px 0', marginBottom: 4 }}>
                {WEEKDAY_LABELS.map((day) => (
                    <div key={day} style={{ flex: 1, textAlign: 'center', fontFamily: 'Roboto, sans-serif', fontSize: 11, color: '#636363' }}>
                        {day}
                    </div>
                ))}
            </div>
            {rows.map((row, i) => (
                <div key={i} style={{ display: 'flex' }}>
                    {row.map(({ date, inMonth }) => {
                        const isSelected = selectedDate && date.isSame(selectedDate, 'day');
                        const isDisabled = disabledDate ? disabledDate(date) : false;
                        return (
                            <div key={date.format('YYYY-MM-DD')} style={{ flex: 1, display: 'flex', justifyContent: 'center', padding: '3px 0' }}>
                                <div
                                    onClick={() => {
                                        if (!isDisabled) {
                                            onSelectDate(date);
                                        }
                                    }}
                                    style={{
                                        width: 26,
                                        height: 26,
                                        borderRadius: '50%',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        cursor: isDisabled ? 'not-allowed' : 'pointer',
                                        fontFamily: 'Roboto, sans-serif',
                                        fontSize: 13,
                                        fontWeight: isSelected ? 700 : 400,
                                        color: isSelected ? '#FFFFFF' : isDisabled ? '#D9D9D9' : inMonth ? '#191919' : '#AEAEAE',
                                        background: isSelected ? '#594099' : 'transparent',
                                    }}
                                >
                                    {date.date()}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ))}
        </div>
    );
};

// Nearest ancestor that clips its content by scrolling (the drawer body),
// falling back to the viewport — this is the area the calendar must fit in.
function getVisibleBounds(el) {
    let node = el ? el.parentElement : null;
    while (node && node !== document.body) {
        const { overflowY } = window.getComputedStyle(node);
        if (overflowY === 'auto' || overflowY === 'scroll') {
            const rect = node.getBoundingClientRect();
            return { top: Math.max(rect.top, 0), bottom: Math.min(rect.bottom, window.innerHeight) };
        }
        node = node.parentElement;
    }
    return { top: 0, bottom: window.innerHeight };
}

// Start/End date fields — always renders the 12px label above the field so
// side-by-side Start date and End date fields are always perfectly aligned
// regardless of whether either field is filled or empty.
const DateField = ({ label, value, onChange, style, alignRight, disabledDate, disabled, defaultViewDate }) => {
    const hasValue = Boolean(value);
    const [open, setOpen] = useState(false);
    const [viewDate, setViewDate] = useState(() => (value ? value.clone() : (defaultViewDate ? defaultViewDate.clone() : moment())));
    const [openAbove, setOpenAbove] = useState(false);
    const wrapperRef = useRef(null);
    const calendarRef = useRef(null);

    // Runs before paint: measure the rendered calendar and open it above the
    // field when it would be cut off below (needing a scroll to see it) but
    // has more room above. Decided only on open so month navigation doesn't flip it.
    useLayoutEffect(() => {
        if (!open || !wrapperRef.current || !calendarRef.current) {
            setOpenAbove(false);
            return;
        }
        const gap = 8;
        const fieldRect = wrapperRef.current.getBoundingClientRect();
        const calendarHeight = calendarRef.current.offsetHeight + gap;
        const bounds = getVisibleBounds(wrapperRef.current);
        const spaceBelow = bounds.bottom - fieldRect.bottom;
        const spaceAbove = fieldRect.top - bounds.top;
        setOpenAbove(spaceBelow < calendarHeight && spaceAbove > spaceBelow);
    }, [open]);

    useEffect(() => {
        if (disabled && open) {
            setOpen(false);
        }
    }, [disabled, open]);

    useEffect(() => {
        if (open) {
            setViewDate(value ? value.clone() : (defaultViewDate ? defaultViewDate.clone() : moment()));
        }
    }, [open, value, defaultViewDate]);

    useEffect(() => {
        if (!open) return undefined;
        const handleClickOutside = (e) => {
            if (wrapperRef.current && !wrapperRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, [open]);

    const handleToggle = () => {
        if (disabled) return;
        setOpen((prev) => !prev);
    };

    return (
        <div ref={wrapperRef} style={{ ...style, position: 'relative', opacity: disabled ? 0.5 : 1 }}>
            <label
                onClick={handleToggle}
                style={{
                    display: 'block',
                    color: '#636363',
                    fontSize: 12,
                    fontWeight: 400,
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    height: 16,
                    lineHeight: '16px',
                    marginBottom: 2,
                    userSelect: 'none',
                }}
            >
                {label}
            </label>
            <div
                onClick={handleToggle}
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    cursor: disabled ? 'not-allowed' : 'pointer',
                    height: 24,
                    userSelect: 'none',
                }}
            >
                <span style={{ fontFamily: 'Roboto, sans-serif', fontSize: 16, color: hasValue ? '#191919' : '#AEAEAE' }}>
                    {hasValue && value ? value.format('DD/MM/YYYY') : 'DD/MM/YYYY'}
                </span>
                <img src={calendarIcon} alt="" style={{ width: 24, height: 24, cursor: disabled ? 'not-allowed' : 'pointer' }} />
            </div>
            <div style={{ borderBottom: '1px solid #E6E6E6', marginTop: 4 }} />
            {!disabled && open && (
                <div
                    ref={calendarRef}
                    style={{
                        position: 'absolute',
                        ...(openAbove ? { bottom: '100%', marginBottom: 8 } : { top: '100%', marginTop: 8 }),
                        ...(alignRight ? { right: 0 } : { left: 0 }),
                        zIndex: 1050,
                    }}
                >
                    <CustomCalendar
                        viewDate={viewDate}
                        selectedDate={value}
                        disabledDate={disabledDate}
                        onSelectDate={(date) => {
                            onChange(date);
                            setOpen(false);
                        }}
                        onPrevMonth={() => setViewDate((d) => d.clone().subtract(1, 'month'))}
                        onNextMonth={() => setViewDate((d) => d.clone().add(1, 'month'))}
                    />
                </div>
            )}
        </div>
    );
};

// A temporary block with nothing picked yet (no geofence, no dates).
const isEmptyTemporary = (item) => item?.type === 'Temporary' && !item.geoFenceId && !item.startDate && !item.endDate;

function hasDataChanged(rawCurrentData, rawInitialData) {
    if (!rawInitialData || rawInitialData.length === 0) return false;
    if (!rawCurrentData || rawCurrentData.length === 0) return false;
    // Empty temporary blocks (the default placeholder, a blank ADD NEW, or
    // one removed again) aren't real changes.
    const currentData = rawCurrentData.filter(item => !isEmptyTemporary(item));
    const initialData = rawInitialData.filter(item => !isEmptyTemporary(item));
    if (currentData.length !== initialData.length) return true;

    for (let i = 0; i < currentData.length; i++) {
        const curr = currentData[i];
        const init = initialData[i];
        if (!curr || !init) return true;

        const currId = curr.geoFenceId ? curr.geoFenceId.toString() : null;
        const initId = init.geoFenceId ? init.geoFenceId.toString() : null;
        if (currId !== initId) return true;

        const currType = curr.type || null;
        const initType = init.type || null;
        if (currType !== initType) return true;

        const currStart = curr.startDate || null;
        const initStart = init.startDate || null;
        if (currStart !== initStart) return true;

        const currEnd = curr.endDate || null;
        const initEnd = init.endDate || null;
        if (currEnd !== initEnd) return true;
    }
    return false;
}

const LocationDrawer = ({ locationDrawerVisible, setLocationDrawerVisible, geoFence, teachersGeofenceLocDataContainer, editedGeoFenceData, storeEditedGeoFenceData, getTeachersGeofenceLocations, getHolidays, params, postAllocateGeoLocation, postSaveEditedGeoFence, isAddMode }) => {
    const [reload, setReload] = useState(1);
    const [options, setOptions] = useState([]);
    const [checkD, setCheckD] = useState(false);
    const [btnDisabled, setBtnDisabled] = useState(false);
    const [isDeleted, setIsDeleted] = useState(false);
    const [startDateValue, setStartDateValue] = useState('');
    const [endDateValue, setEndDateValue] = useState('');
    const [buttonLoader, setButtonLoader] = useState(false);
    const [permanentGeoFence, setPermanentGeoFence] = useState(null);
    const [initialGeoFenceData, setInitialGeoFenceData] = useState([]);

    const handleSaveClick = async () => {
        setButtonLoader(true);

        const isGlobal = editedGeoFenceData.some(item =>
            item.type === 'Permanent' && item.title && item.title.trim().toLowerCase() === 'global'
        );

        if (isAddMode) {
            // Add mode: allocate geofence first time using postAllocateGeoLocation
            const geoFencesToSave = editedGeoFenceData
                .filter(item => {
                    if (!item.geoFenceId) return false;
                    if (isGlobal) {
                        return item.type === 'Permanent';
                    }
                    return true;
                })
                .map(item => ({
                    geoFenceId: item.geoFenceId,
                    type: item.type,
                    startDate: item.startDate,
                    endDate: item.endDate
                }));

            if (geoFencesToSave.length === 0) {
                setButtonLoader(false);
                return;
            }

            const currentUserId = Number(params?.userId);

            if (geoFencesToSave.length === 1) {
                const item = geoFencesToSave[0];
                const payload = {
                    type: item.type,
                    startDate: item.type === 'Permanent' ? null : item.startDate,
                    endDate: item.type === 'Permanent' ? null : item.endDate,
                    userIds: [currentUserId],
                    geoFenceIds: [Number(item.geoFenceId)]
                };

                postAllocateGeoLocation(
                    payload,
                    () => {
                        setButtonLoader(false);
                    },
                    (response) => {
                        onClose();
                        getHolidays(params, () => { });
                    }
                );
                return;
            }

            // For multiple items, allocate each sequentially
            try {
                for (let i = 0; i < geoFencesToSave.length; i++) {
                    const item = geoFencesToSave[i];
                    const payload = {
                        type: item.type,
                        startDate: item.type === 'Permanent' ? null : item.startDate,
                        endDate: item.type === 'Permanent' ? null : item.endDate,
                        userIds: [currentUserId],
                        geoFenceIds: [Number(item.geoFenceId)]
                    };
                    await new Promise((resolve) => {
                        postAllocateGeoLocation(
                            payload,
                            () => { },
                            () => { resolve(); }
                        );
                        setTimeout(resolve, 3000);
                    });
                }
                setButtonLoader(false);
                onClose();
                getHolidays(params, () => { });
            } catch (err) {
                setButtonLoader(false);
            }
        } else {
            // Edit mode: save edited geofences using postSaveEditedGeoFence
            let geoFencesList = [];
            if (isGlobal) {
                const perm = editedGeoFenceData.find(item => item.type === 'Permanent' && item.geoFenceId);
                if (perm) {
                    geoFencesList.push({
                        geoFenceId: perm.geoFenceId.toString(),
                        type: 'Permanent'
                    });
                }
            } else {
                editedGeoFenceData.forEach(item => {
                    if (!item.geoFenceId) return;
                    if (item.type === 'Permanent') {
                        geoFencesList.push({
                            geoFenceId: item.geoFenceId.toString(),
                            type: 'Permanent'
                        });
                    } else if (item.type === 'Temporary' && item.startDate && item.endDate) {
                        geoFencesList.push({
                            geoFenceId: item.geoFenceId.toString(),
                            type: 'Temporary',
                            startDate: item.startDate,
                            endDate: item.endDate
                        });
                    }
                });
            }

            if (geoFencesList.length === 0) {
                setButtonLoader(false);
                return;
            }

            const payload = {
                userId: params?.userId?.toString(),
                geoFences: geoFencesList
            };

            postSaveEditedGeoFence(
                payload,
                () => {
                    setButtonLoader(false);
                },
                () => {
                    onClose();
                    getHolidays(params, () => { });
                }
            );
        }
    };

    function disabledDate(current) {
        return current < moment().startOf('day');
    }

    console.log("editedGeoFenceData", editedGeoFenceData);

    function disabledEndDate(current) {
        return current < moment(startDateValue);
    }

    const onClose = () => {
        setLocationDrawerVisible(false);
    };

    // The drawer stays mounted while closed, so its content keeps the old
    // scroll position — always reopen from the top.
    // Reset on the next frames: when `visible` flips the drawer isn't shown
    // yet, and scrollTop on a hidden element is ignored.
    const scrollBodyRef = useRef(null);
    useEffect(() => {
        if (!locationDrawerVisible) return undefined;
        const resetScroll = () => {
            const el = scrollBodyRef.current;
            if (!el) return;
            el.scrollTop = 0;
            const drawerBody = el.closest('.ant-drawer-body');
            if (drawerBody) drawerBody.scrollTop = 0;
        };
        resetScroll();
        let raf2;
        const raf1 = requestAnimationFrame(() => {
            resetScroll();
            raf2 = requestAnimationFrame(resetScroll);
        });
        return () => {
            cancelAnimationFrame(raf1);
            if (raf2) cancelAnimationFrame(raf2);
        };
    }, [locationDrawerVisible]);

    useEffect(() => {
        if (locationDrawerVisible) {
            getTeachersGeofenceLocations();
            getHolidays(params, () => { })
        }
    }, [locationDrawerVisible, params.userId]);

    // Set once the user adds, removes or edits a block; reset when the drawer
    // closes. The getHolidays refresh on open changes `geoFence` a moment
    // later, and rebuilding then wiped a just-added "Temporary location N".
    const userEditedRef = useRef(false);

    // Initialize data when drawer opens
    useEffect(() => {
        if (!locationDrawerVisible) {
            userEditedRef.current = false;
            return;
        }
        if (userEditedRef.current) return;
        {
            let temp = [];

            if (isAddMode) {
                // For add mode: Create a permanent entry and one temporary entry
                temp = [
                    {
                        geoFenceId: null,
                        title: '',
                        type: 'Permanent',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    },
                    {
                        geoFenceId: null,
                        title: '',
                        type: 'Temporary',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    }
                ];
            } else if (geoFence?.allAllocations?.some(a => a?.geoFence && !a.geoFence.deleted)) {
                // Edit mode with `allAllocations` (every location allocated to
                // the user): load all of them — permanent first, then the
                // temporaries by start date — so they show in the drawer and
                // are kept when saving (save sends the full list).
                const allocations = geoFence.allAllocations.filter(a => a?.geoFence && !a.geoFence.deleted);
                const toEntry = (a) => ({
                    title: a.geoFence.title,
                    geoFenceId: a.geoFence.id?.toString(),
                    type: String(a.type || '').trim().toLowerCase() === 'temporary' ? 'Temporary' : 'Permanent',
                    startDate: a.startDate ? moment(a.startDate).format("YYYY-MM-DD") : null,
                    endDate: a.endDate ? moment(a.endDate).format("YYYY-MM-DD") : null,
                });
                const entries = allocations.map(toEntry);
                temp = [
                    ...entries.filter(e => e.type === 'Permanent'),
                    ...entries
                        .filter(e => e.type === 'Temporary')
                        .sort((a, b) => moment(a.startDate || 0).valueOf() - moment(b.startDate || 0).valueOf()),
                ];

                // Same placeholders as the `geofences` branch below.
                if (!temp.some(e => e.type === 'Permanent')) {
                    temp.unshift({ geoFenceId: null, title: '', type: 'Permanent', startDate: null, endDate: null, isNew: true });
                }
                if (!temp.some(e => e.type === 'Temporary')) {
                    temp.push({ geoFenceId: null, title: '', type: 'Temporary', startDate: null, endDate: null, isNew: true });
                }
            } else if (geoFence?.geofences?.length > 0) {
                // For edit mode: Use existing data
                geoFence.geofences.forEach(geoFence => {
                    temp.push({
                        title: geoFence.title,
                        geoFenceId: geoFence.id?.toString(),
                        type: geoFence.type,
                        startDate: geoFence.startDate ? moment(geoFence.startDate).format("YYYY-MM-DD") : null,
                        endDate: geoFence.endDate ? moment(geoFence.endDate).format("YYYY-MM-DD") : null,
                    });
                });

                // Ensure at least one permanent geofence field is available
                const hasPermanent = temp.some(geoFence => geoFence.type === 'Permanent');
                if (!hasPermanent) {
                    temp.unshift({
                        geoFenceId: null,
                        title: '',
                        type: 'Permanent',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    });
                }

                // Ensure at least one temporary geofence field is available
                const hasTemporary = temp.some(geoFence => geoFence.type === 'Temporary');
                if (!hasTemporary) {
                    temp.push({
                        geoFenceId: null,
                        title: '',
                        type: 'Temporary',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    });
                }
            } else if (geoFence?.currentLocation?.id) {
                // For edit mode when response only has currentLocation:
                const locType = geoFence.currentLocation.type || 'Permanent';
                if (locType === 'Temporary') {
                    temp.push({
                        geoFenceId: null,
                        title: '',
                        type: 'Permanent',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    });
                    temp.push({
                        title: geoFence.currentLocation.title,
                        geoFenceId: geoFence.currentLocation.id?.toString(),
                        type: 'Temporary',
                        startDate: geoFence.currentLocation.startDate ? moment(geoFence.currentLocation.startDate).format("YYYY-MM-DD") : null,
                        endDate: geoFence.currentLocation.endDate ? moment(geoFence.currentLocation.endDate).format("YYYY-MM-DD") : null,
                    });
                } else {
                    temp.push({
                        title: geoFence.currentLocation.title,
                        geoFenceId: geoFence.currentLocation.id?.toString(),
                        type: 'Permanent',
                        startDate: null,
                        endDate: null,
                    });
                    temp.push({
                        geoFenceId: null,
                        title: '',
                        type: 'Temporary',
                        startDate: null,
                        endDate: null,
                        isNew: true
                    });
                }
            }

            storeEditedGeoFenceData(temp);
            setInitialGeoFenceData(JSON.parse(JSON.stringify(temp)));
            setCheckD(!checkD);
        }
    }, [locationDrawerVisible, geoFence, isAddMode]);

    useEffect(() => {
        const temp = teachersGeofenceLocDataContainer.map(item => ({
            value: item.title,
            key: item.id,
        }));
        setOptions(temp);
    }, [teachersGeofenceLocDataContainer, isDeleted]);

    useEffect(() => {
        function checkDisable() {
            let disabled = false;
            // A temporary location picked without both dates (or with end < start).
            let hasInvalidTemporary = false;

            // In edit mode: user must change something, otherwise SAVE is disabled
            if (!isAddMode) {
                const changed = hasDataChanged(editedGeoFenceData, initialGeoFenceData);
                if (!changed) {
                    setBtnDisabled(true);
                    return;
                }
            }

            if (editedGeoFenceData?.length > 0) {
                const permanentItem = editedGeoFenceData.find(item => item.type === 'Permanent');
                const isGlobal = permanentItem?.title && permanentItem.title.trim().toLowerCase() === 'global';

                if (isGlobal) {
                    disabled = !permanentItem?.geoFenceId;
                    setBtnDisabled(disabled);
                    return;
                }

                const hasValidPermanent = editedGeoFenceData.some(item =>
                    item.type === 'Permanent' && item.geoFenceId
                );

                const hasValidTemporary = editedGeoFenceData.some(item =>
                    item.type === 'Temporary' && item.geoFenceId && item.startDate && item.endDate
                );

                // At least one valid permanent or temporary geofence must be configured
                if (!hasValidPermanent && !hasValidTemporary) {
                    disabled = true;
                }

                // Any temporary geofence that is partially filled must block saving
                hasInvalidTemporary = editedGeoFenceData.some(item => {
                    if (item.type !== 'Temporary') return false;
                    const hasAny = Boolean(item.geoFenceId || item.startDate || item.endDate);
                    const hasAll = Boolean(item.geoFenceId && item.startDate && item.endDate);
                    if (hasAny && !hasAll) return true;
                    if (hasAll && moment(item.endDate).isBefore(moment(item.startDate), 'day')) return true;
                    return false;
                });

                if (hasInvalidTemporary) {
                    disabled = true;
                }
            } else {
                disabled = true;
            }

            // After a REMOVE, re-enable SAVE only if that changed something
            // (removing a block that was just filled in is no change).
            // Never while a temporary location is half-filled (e.g. no dates yet).
            if (isDeleted && !hasInvalidTemporary && (isAddMode || hasDataChanged(editedGeoFenceData, initialGeoFenceData))) {
                const hasValidPermanent = editedGeoFenceData?.some(item =>
                    item.type === 'Permanent' && item.geoFenceId
                );
                const hasValidTemporary = editedGeoFenceData?.some(item =>
                    item.type === 'Temporary' && item.geoFenceId && item.startDate && item.endDate
                );
                if (hasValidPermanent || hasValidTemporary) {
                    disabled = false;
                }
            }

            setBtnDisabled(disabled);
        }
        checkDisable();
    }, [checkD, reload, editedGeoFenceData, isDeleted, initialGeoFenceData, isAddMode]);

    function onFillMultiple(index, updates) {
        userEditedRef.current = true;
        const updatedData = [...editedGeoFenceData];
        updatedData[index] = {
            ...updatedData[index],
            ...updates,
        };
        storeEditedGeoFenceData(updatedData);
        setCheckD(!checkD);
    }

    function onFill(index, key, val) {
        onFillMultiple(index, { [key]: val });
    }

    const onSelect = (value, obj, index) => {
        const geoId = (obj?.key || obj?.id || obj?.value || '').toString();
        onFillMultiple(index, {
            geoFenceId: geoId,
            title: value,
        });
    };

    const deleteLocation = (id) => {
        userEditedRef.current = true;
        let temp = [...editedGeoFenceData];
        temp.splice(id, 1);
        storeEditedGeoFenceData([...temp]);
        setIsDeleted(true);
        setCheckD(!checkD);
    };

    // Options for one block: everything except locations picked in the other blocks.
    const getAvailableOptions = (index) => {
        const taken = new Set(
            (editedGeoFenceData || [])
                .filter((it, i) => i !== index && it.geoFenceId)
                .map((it) => String(it.geoFenceId))
        );
        return options.filter((o) => !taken.has(String(o.key)));
    };

    // Separate permanent and temporary items
    const permanentItems = editedGeoFenceData?.filter(item => item.type === 'Permanent') || [];
    const temporaryItems = editedGeoFenceData?.filter(item => item.type === 'Temporary') || [];
    const isGlobalPermanent = permanentItems.some(item => item.title && item.title.trim().toLowerCase() === 'global');

    return (
        <Drawer
            placement="right"
            visible={locationDrawerVisible}
            width={`32%`}
            closable={false}
            onClose={onClose}
        >
            <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
                {/* Header - Fixed */}
                <div className='drawer-title' style={{ flexShrink: 0 }}>
                    <div style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500, fontSize: 18, color: '#191919' }}>{isAddMode ? 'Add geofences' : 'Update geofences'}</div>
                    <div><CloseOutlined style={{ color: '#AEAEAE' }} onClick={onClose} /></div>
                </div>

                {/* Scrollable Content */}
                <div ref={scrollBodyRef} style={{ flex: 1, overflowY: 'auto', paddingBottom: '20px' }}>
                    {/* Permanent Location Section */}
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 16, padding: 20, }}>
                            <div><img style={{ height: 48, width: 48 }} src={pLocation} /></div>
                            <div style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500, fontSize: 17, color: '#191919' }}>Permanent location</div>
                        </div>
                        <div style={{ width: '100%', paddingLeft: 20, paddingRight: 20 }}>
                            {/* <label style={{ color: '#636363', fontSize: 12, fontWeight: 400 }}>Assign Permanent geofence</label> */}
                            {permanentItems.map((item, index) => {
                                const originalIndex = editedGeoFenceData.indexOf(item);
                                return (
                                    <FloatingLabelSelect
                                        key={originalIndex}
                                        label="Assign Permanent geofence"
                                        required
                                        value={item.title}
                                        options={getAvailableOptions(originalIndex)}
                                        onSelect={(val, obj) => onSelect(val, obj, originalIndex)}
                                    />
                                );
                            })}
                            {/* Global permanent: temporary locations are hidden — say why. */}
                            {isGlobalPermanent && (
                                <div style={{ marginTop: 8, fontFamily: 'Roboto, sans-serif', fontSize: 13, fontWeight: 400, color: '#FF414D' }}>
                                    Since the global location is permanent, you cannot assign other locations.
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Temporary Locations Section - only shown if permanent location is NOT Global */}
                    {!isGlobalPermanent && (
                        <>
                            {temporaryItems.map((item, index) => {
                                const originalIndex = editedGeoFenceData.indexOf(item);
                                const temporaryIndex = temporaryItems.indexOf(item) + 1;
                                return (
                                    <div key={originalIndex} style={{ padding: 10 }}>
                                        <div className='loc-geofence'>
                                            <div style={{ display: "flex", alignItems: 'center', gap: 16 }}>
                                                <div><img style={{ height: 48, width: 48 }} src={tLocation} /></div>
                                                <div style={{ fontFamily: 'Roboto, sans-serif', fontWeight: 500, fontSize: 17, color: '#191919' }}>Temporary location {temporaryIndex}</div>
                                            </div>
                                            {/* REMOVE when there are several, or when this one
                                                has anything filled in (so a lone temporary
                                                location can be dropped too). */}
                                            {(temporaryItems.length > 1 || !isEmptyTemporary(item)) && (
                                                <div
                                                    style={{ marginTop: 10, color: "#FF414D", fontSize: '13px', fontWeight: 500, cursor: 'pointer' }}
                                                    onClick={() => { deleteLocation(originalIndex) }}
                                                >
                                                    REMOVE
                                                </div>
                                            )}
                                        </div>
                                        <div style={{ width: '100%', paddingLeft: 20, paddingRight: 20 }}>
                                            {/* <label style={{ color: '#636363', fontSize: 12, fontWeight: 400 }}>Assign temporary geofence</label> */}
                                            <FloatingLabelSelect
                                                key={`${originalIndex}-select`}
                                                label="Assign temporary geofence"
                                                value={item.title}
                                                options={getAvailableOptions(originalIndex)}
                                                onSelect={(val, obj) => onSelect(val, obj, originalIndex)}
                                            />
                                        </div>
                                        <div style={{ display: "flex", justifyContent: "space-between", marginTop: "10px", paddingLeft: 20, paddingRight: 20 }}>
                                            <DateField
                                                label="Start date"
                                                style={{ width: "48%", marginTop: 20 }}
                                                value={item.startDate ? moment(item.startDate) : null}
                                                disabledDate={(current) => current ? current.isBefore(moment(), 'day') : false}
                                                onChange={(e) => {
                                                    const nextStart = e ? e.format("YYYY-MM-DD") : null;
                                                    if (!nextStart) {
                                                        onFillMultiple(originalIndex, { startDate: null, endDate: null });
                                                    } else if (item.endDate && moment(item.endDate).isBefore(moment(nextStart), 'day')) {
                                                        onFillMultiple(originalIndex, { startDate: nextStart, endDate: null });
                                                    } else {
                                                        onFill(originalIndex, "startDate", nextStart);
                                                    }
                                                }}
                                            />
                                            <DateField
                                                label="End date"
                                                style={{ width: "48%", marginTop: 20 }}
                                                alignRight={true}
                                                disabled={!item.startDate}
                                                defaultViewDate={item.startDate ? moment(item.startDate) : null}
                                                value={item.endDate ? moment(item.endDate) : null}
                                                disabledDate={(current) => {
                                                    if (!current) return false;
                                                    if (item.startDate) {
                                                        return current.isBefore(moment(item.startDate), 'day');
                                                    }
                                                    return current.isBefore(moment(), 'day');
                                                }}
                                                onChange={(e) => { onFill(originalIndex, "endDate", e ? e.format("YYYY-MM-DD") : null); }}
                                            />
                                        </div>
                                    </div>
                                );
                            })}

                            {/* Add New Button */}
                            <div style={{ paddingRight: 20, display: "flex", justifyContent: "right" }}>
                                <Button
                                    type='link'
                                    style={{ color: "#594099", fontWeight: "bold", border: "none", fontSize: 13 }}
                                    onClick={() => {
                                        const tmp = {
                                            geoFenceId: null,
                                            type: 'Temporary',
                                            startDate: null,
                                            endDate: null,
                                            isNew: true
                                        };
                                        userEditedRef.current = true;
                                        storeEditedGeoFenceData([...editedGeoFenceData, tmp]);
                                        setReload(reload + 1);
                                        setCheckD(!checkD);
                                    }}
                                >
                                    ADD NEW
                                </Button>
                            </div>
                        </>
                    )}
                </div>

                {/* Footer Buttons - Fixed at bottom */}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: '20px',
                        // borderTop: '1px solid #f0f0f0',
                        flexShrink: 0,
                        backgroundColor: 'white'
                    }}
                >
                    <Button
                        style={{
                            backgroundColor: "#FFFFFF",
                            color: "#AEAEAE",
                            borderRadius: 8,
                            border: '2px solid #AEAEAE',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            fontWeight: 500,
                            padding: '0 30px'
                        }}
                        onClick={onClose}
                    >
                        CANCEL
                    </Button>
                    <Button
                        loading={buttonLoader}
                        className="m-l-30"
                        style={{
                            borderRadius: 8,
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            backgroundColor: "#594099",
                            color: '#FFFFFF',
                            padding: '0 30px'
                        }}
                        type="primary"
                        onClick={handleSaveClick}
                        disabled={btnDisabled}
                    >
                        SAVE
                    </Button>
                </div>
            </div>
        </Drawer>
    )
}

const mapStateToProps = (state) => {
    const { teachersGeofenceLocDataContainer, editedGeoFenceData } = state.attendanceNew;
    return { teachersGeofenceLocDataContainer, editedGeoFenceData };
};

const mapDispatchToProps = (dispatch) => ({
    storeEditedGeoFenceData: (val) => dispatch(storeEditedGeoFenceData(val)),
    getTeachersGeofenceLocations: () => dispatch(getTeachersGeofenceLocations()),
    postAllocateGeoLocation: (object, callback, successCallback) => dispatch(postAllocateGeoLocation(object, callback, successCallback)),
    postSaveEditedGeoFence: (payload, callback, successCallback) => dispatch(postSaveEditedGeoFence(payload, callback, successCallback))
});

export default connect(mapStateToProps, mapDispatchToProps)(LocationDrawer);